import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const initialState = {
  token: Cookies.get("roam-token") || null,
  user: null,
  isAuthenticated: !!Cookies.get("roam-token"),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { token, user } = action.payload;
      state.token = token;
      state.user = user;
      state.isAuthenticated = true;
      Cookies.set("roam-token", token, { expires: 7 }); // 7 days
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
      state.isAuthenticated = false;
      Cookies.remove("roam-token");
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;